import { axios, Response } from '..'

export interface CreateTaskRequest {
  id: string
  title: string
  description?: string
  startDate?: string
  endDate?: string
  status: string
  files?: SaveFileRequest[]
  membersIds?: string[]
  taskTagsIds?: number[]
  checklists?: ChecklistRequest[]
}

interface SaveFileRequest {
  fileName: string
  fileContentType: string
}

export interface ChecklistRequest {
  id: string
  title: string
  checklistItems?: ChecklistItemRequest[]
}

export interface ChecklistItemRequest {
  checklistItemId: string
  title: string
  responsibleForTheDemandId?: string
}

export const createTask = (
  createTaskRequest: CreateTaskRequest
): Response<null> => {
  return axios.post('/v1/tasks/', createTaskRequest)
}
